import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Import Containers
import { DefaultLayoutComponent } from './containers';
import { SecureInnerPagesGuard } from './shared/secure-inner-pages.guard';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';



export const routes: Routes = [
  { path: '404', component: P404Component, data: { title: 'Page 404' } },
  { path: '500', component: P500Component, data: { title: 'Page 500' } },
  { path: 'home', redirectTo: 'home/dashboard', pathMatch: 'full' },
  { path: '', redirectTo: 'home/dashboard', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [SecureInnerPagesGuard],
    loadChildren: () => import('./views/login/login.module').then(m => m.LoginModule),

  },
  {
    path: 'home',
    component: DefaultLayoutComponent,
    data: { breadcrumb: { label: 'Dashboard' } },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { breadcrumb: { label: 'Dashboard' } }
      },
      {
        path: '',
        loadChildren: () => import('./views/incoming-outgoing-vehicles/incoming-outgoing-vehicles.module').then(m => m.IncomingOutgoingVehiclesModule),
      },
      {
        path: 'map',
        loadChildren: () => import('./views/maps/maps.module').then(m => m.MapsModule),
        data: { breadcrumb: 'Map' }
      },
      {
        path: 'policing',
        loadChildren: () => import('./views/policing/policing.module').then(m => m.PolicingModule),
        data: { breadcrumb: 'Policing' }
      },
      {
        path: 'pricing',
        loadChildren: () => import('./views/pricing/pricing.module').then(m => m.PricingModule),
        data: { breadcrumb: 'Pricing Policy' }
      },
      {
        path: '',
        loadChildren: () => import('./views/sensors/sensors-view.module').then(m => m.SensorsViewModule),
      },
      {
        path: 'groups',
        loadChildren: () => import('./views/groups/groups.module').then(m => m.GroupsModule),
        data: { breadcrumb: 'Groups' }
      },
      {
        path: 'rules',
        loadChildren: () => import('./views/rules/rules.module').then(m => m.RulesModule),
        data: { breadcrumb: 'Rules' },
      },
      {
        path: 'users-management',
        loadChildren: () => import('./views/user-management/user-management.module').then(m => m.UserManagementModule),
      },
      {
        path: 'account',
        loadChildren: () => import('./views/account/account.module').then(m => m.AccountModule),
        data: { breadcrumb: { label: 'Account' } }
      },
      {
        path: 'contact',
        loadChildren: () => import('./views/contact/contact.module').then(m => m.ContactModule),
        data: { breadcrumb: { label: 'Contact' } }
      },
      {
        path: 'booking',
        loadChildren: () => import('./views/booking/booking.module').then(m => m.BookingModule),
        data: { breadcrumb: { label: 'Booking' } }
      },
      
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
